/* eslint-disable */
import {VMoney} from 'v-money'
import {mask} from 'vue-the-mask'

export default {
  data() {
    return {
      setPage: false,
      show_list: false,
      itemsPerPage: 15
    }
  },
  directives: {money: VMoney, mask},
  methods: {
    set_por_paginas(itemsPerPage) {
      this.itemsPerPage = itemsPerPage
    },
  }
}
